import { render } from "./frameworks.vue?vue&type=template&id=8085a8d0&scoped=true&ts=true"
import script from "./frameworks.vue?vue&type=script&lang=ts"
export * from "./frameworks.vue?vue&type=script&lang=ts"

import "./frameworks.vue?vue&type=style&index=0&id=8085a8d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8085a8d0"]])

export default __exports__